<template>
  <div class="statusTop">
    <div class="topLogo">
      <img src="@/assets/images/yujian-logo.jpg" alt="遇健海南">
      <div class="brandText">
        <strong>遇健海南</strong>
        <span>商户入驻服务</span>
      </div>
    </div>
    <p>请认真填写申请信息，以便我们为您提供更好的服务！</p>
  </div>
</template>

<script>
export default {
  name: 'centLogo'
}
</script>

<style lang="scss" scoped>
.statusTop {
  // width: 350px;
  width: 500px;
  margin: 50px auto 40px auto;
  .topLogo {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    img {
      width: 88px;
      height: 88px;
      object-fit: cover;
      border: 3px solid rgba(255, 255, 255, 0.9);
      border-radius: 50%;
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.16);
    }
    .brandText {
      display: flex;
      flex-direction: column;
      margin-left: 16px;
      text-align: left;
      strong { color: #FFFFFF; font-size: 26px; letter-spacing: 2px; }
      span { color: #F2D99A; font-size: 13px; margin-top: 7px; letter-spacing: 3px; }
    }
  }
  p {
    color: #FFEBC4;
    font-size: 14px;
    margin-top: 20px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/centLogo.vue